import React from "react";
import {
  FaWix,
  FaWordpress,
  FaShopify,
  FaSquarespace,
  FaDrupal,
  FaJoomla,
  FaWeebly,
  FaGhost,
  FaBlogger,
  FaTypo3,
  FaOpencart,
  FaMagento,
} from "react-icons/fa";
import { FaWebflow } from "react-icons/fa6";
import { SiBigcommerce, SiPrestashop } from "react-icons/si";
import { InfiniteMarquee } from "./InfiniteMarquee";
import { Tooltip } from "react-tooltip";

const Section2 = () => {
  const logocss =
    "min-h-[80px] min-w-[80px] text-primary fill-primary p-1 -mx-2 rounded-full bg-white hover:scale-110";
  return (
    <section className="flex h-fit overflow-hidden  flex-1 w-full  flex-col my-10  pt-10 rounded-xl text-white bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-[#b421ec] via-[#490863] to-[#0E0113]">
      <div className="text-center text-3xl sm:text-5xl font-semibold">
        <span className="bg-gradient-to-l from-lightprimary via-red-500 to-indigo-500 text-transparent bg-clip-text">
          Seamless Integration,
        </span>{" "}
        Endless Possibilities
      </div>
      <div className="flex justify-center">
        <div className=" max-w-[900px] text-center text-base px-10 sm:text-lg mt-4 text-gray-200">
          Easily integrate our AI-powered chatbot with any platform and unlock
          limitless automation possibilities.
        </div>
      </div>
      <InfiniteMarquee duration={15}>
        {[
          {
            id: "wix",
            icon: <FaWix className={logocss} />,
            label: "Wix",
          },
          {
            id: "wordpress",
            icon: <FaWordpress className={logocss} />,
            label: "WordPress",
          },
          {
            id: "shopify",
            icon: <FaShopify className={logocss} />,
            label: "Shopify",
          },
          {
            id: "squarespace",
            icon: <FaSquarespace className={logocss} />,
            label: "Squarespace",
          },
          {
            id: "drupal",
            icon: <FaDrupal className={logocss} />,
            label: "Drupal",
          },
          {
            id: "joomla",
            icon: <FaJoomla className={logocss} />,
            label: "Joomla",
          },
          {
            id: "weebly",
            icon: <FaWeebly className={logocss} />,
            label: "Weebly",
          },
          {
            id: "ghost",
            icon: <FaGhost className={logocss} />,
            label: "Ghost",
          },
          {
            id: "blogger",
            icon: <FaBlogger className={logocss} />,
            label: "Blogger",
          },
          {
            id: "bigcommerce",
            icon: <SiBigcommerce className={logocss} />,
            label: "BigCommerce",
          },
          {
            id: "typo3",
            icon: <FaTypo3 className={logocss} />,
            label: "TYPO3",
          },
          {
            id: "opencart",
            icon: <FaOpencart className={logocss} />,
            label: "OpenCart",
          },
          {
            id: "magento",
            icon: <FaMagento className={logocss} />,
            label: "Magento",
          },
          {
            id: "webflow",
            icon: <FaWebflow className={logocss} />,
            label: "Webflow",
          },
          {
            id: "prestashop",
            icon: <SiPrestashop className={logocss} />,
            label: "PrestaShop",
          },
        ].map(({ id, icon, label }) => (
          <>
            <div id={id} className="mx-4">
              {icon}
            </div>
            <Tooltip
              anchorSelect={`#${id}`}
              place="left-end"
              variant="dark"
              float={true}>
              <span>{label}</span>
            </Tooltip>
          </>
        ))}
      </InfiniteMarquee>
      <p className="px-10 py-5 text-base sm:text-lg">
        No matter what platform your website is built on, our AI-based chatbot
        service ensures smooth integration to enhance visitor engagement and
        improve customer interactions on your website.
      </p>
    </section>
  );
};

export default Section2;
